import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  showJobs(event) {
    event.preventDefault();
    Turbo.visit("/?search_tab=jobs", { frame: "top_search" });
  }

  showCompanies(event) {
    event.preventDefault();
    Turbo.visit("/?search_tab=companies", { frame: "top_search" });
  }
}
